import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ChannelTableRowComponent } from '../channel-table-row/channel-table-row.component';
import { ChannelFns } from 'ops/common/models/channel';
import { AlarmAnimationService } from '@service/alarm-animation.service';
import { DeviceFlagsService } from '@service/device-flags.service';
import { ResponsiveService } from '@service/responsive.service';

@Component({
    selector: 'app-channel-table-row-compact',
    templateUrl: './channel-table-row-compact.component.html',
    styleUrls: [
        '../channel-table-header/channel-table-header.component.scss',
        '../channel-table-row/channel-table-row.component.scss',
    ],
    standalone: false,
})
export class ChannelTableRowCompactComponent
    extends ChannelTableRowComponent
    implements OnInit, OnDestroy
{
    constructor(
        flagService: DeviceFlagsService,
        alarmAnimation: AlarmAnimationService,
        responsive: ResponsiveService,
        cdr: ChangeDetectorRef,
    ) {
        super(flagService, alarmAnimation, responsive, cdr);
    }

    ngOnInit(): void {
        this.disabled = ChannelFns.isChannelBlank(this.channel);
        this.isDigital = ChannelFns.isDigital(this.channel);
        this.measurementUnit = this.channel.opsData.measurementUnit;
        this.flagsSubscription = this.flagService.onAllFlagsUpdated().subscribe(() => {
            this.channelValue = this.flagService.getFlags(this.channel)?.value;
            this.updateStatusString();
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.flagsSubscription?.unsubscribe();
    }
}
